const DarkMode = {
  value: true,
  get() {
    return this.value
  },
  set(value) {
    this.value = value
    localStorage.setItem('darkMode', this.value)

    const docClasses = document.body.classList
    if (this.value) {
      docClasses.remove('white-content')
    } else {
      docClasses.add('white-content')
    }
    this.selectClass()
  },
  selectClass() {
    return this.value ? 'select-success' : 'select-info'
  }
}

export default ({ app }, inject) => {
  inject('darkMode', DarkMode)

  if (process.browser) {
    app.$darkMode.set(localStorage.getItem('darkMode') ? localStorage.getItem('darkMode') === 'true' : false)
    app.$darkMode.selectClass()
    const docClasses = document.body.classList
    if (!app.$darkMode.get()) docClasses.add('white-content')
  }
}
